<template>
  <div style="max-width:1200px;  margin: auto;" class="pa-3">
    <v-form ref="formSin" v-model="formEmpresa" lazy-validation @submit.prevent>
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field v-model="GetDatosGuardados.resultado.nitEmpresa" label="NIT del Negocio o Empresa"
            maxlength="400" rows="1" :disabled="true" />
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field v-model="GetDatosGuardados.resultado.nombreEmpresa" label="Nombre o Razón Social de la Empresa"
            maxlength="250" rows="3" :disabled="true" />
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field v-model="GetDatosGuardados.resultado.dependencia"
            label="Departamento de Domicilio Fiscal de la Empresa" maxlength="15" rows="3" :disabled="true" />
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field v-model="GetDatosGuardados.resultado.telefonoEmpresa" label="Teléfono de la Empresa"
            maxlength="15" rows="3" :disabled="true" />
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field v-model="GetDatosGuardados.resultado.correoNotificacionEmpresa" label="Correo de la empresa"
            maxlength="15" rows="3" :disabled="true" />
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import types from '@/store/types/SolicitudCredenciales'

export default {
  data() {
    return {
      formEmpresa: false,
    }
  },
  methods: {
    ...mapMutations({
      SetDatosGuardados: types.mutations.SetDatosGuardados,
    }),
  },
  computed: {
    ...mapGetters({
      GetDatosGuardados: types.getters.GetDatosGuardados,
    }),
  }
}
</script>